import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { FinancialStatementResponse } from '../models/financialStatment';

export const onGetFinancialStatements = async () => {
	try {
		const response = await axios.get<JsonResponse<FinancialStatementResponse>>('dashboard/financial-statements');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
